/**
 * utils
 */

const utils = {
  /**
   * 获取页面宽度
   * @return {[type]} [description]
   */
  pageWidth() {
    return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
  },

  /**
   * 获取页面高度
   * @return {[type]} [description]
   */
  pageHeight() {
    return Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
  },

  /**
   * 格式化Table数据，行合并
   * @param {*} data
   * @param {*} key
   */
  formatTableData(data, key) {
    const groupData = [];
    let rankData = [];
    data.forEach(item => {
      if (groupData[item[key]]) {
        groupData[item[key]].push(item);
      } else {
        groupData[item[key]] = [item];
      }
    });
    groupData.map(item => {
      const rankItem = item || [];
      item.forEach((item2, index) => {
        if (index === 0) {
          item2.rowSpan = item.length;
        } else {
          item2.rowSpan = 0;
        }
        return item2;
      });
      rankData = rankData.concat(rankItem);

      return item;
    });
    return rankData;
  },
  /**
   * 根据参数名获取URL数据
   * @param  {[type]} name [description]
   * @param  {[type]} url  [description]
   * @return {[type]}      [description]
   */
  getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[[\]]/g, '\\$&');
    const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
    const results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  },

  /**
   * 获取图片的Base64格式
   * @param  {[type]}   img      [description]
   * @param  {Function} callback [description]
   * @return {[type]}            [description]
   */
  getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  },

  /**
   * 百分比转换
   * @param  {[type]} num       [description]
   * @param  {[type]} precision [description]
   * @return {[type]}           [description]
   */
  percent(num, precision) {
    if (!num || num === Infinity) return `${0}%`;
    if (num > 1) num = 1;
    precision = precision || 2;
    precision = 10 ** precision;
    return `${Math.round(num * precision * 100) / precision}%`;
  },

  /**
   * 格式化数字，格式化金额
   * number：要格式化的数字
   * decimals：保留几位小数
   * decPoint：小数点符号
   * thousandsSep：千分位符号
   */
  numberFormat(number, decimals = 2, decPoint = '.', thousandsSep = ',') {
    number = `${number}`.replace(/[^\d+-Ee]/g, '');
    const n = !isFinite(+number) ? 0 : +number;
    const prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
    const sep = typeof thousandsSep === 'undefined' ? ',' : thousandsSep;
    const dec = typeof decPoint === 'undefined' ? '.' : decPoint;
    let s = '';
    const toFixedFix = (num, pre) => {
      const k = 10 ** pre;
      const k2 = `${num * k}`;
      if (num * k > 0) {
        if (k2.indexOf('.') > 0) {
          if (k2[k2.indexOf('.') + 1] >= 5) {
            return `${Math.ceil(num * k) / k}`;
          }
          return `${Math.floor(num * k) / k}`;
        }
        return `${Math.ceil(num * k) / k}`;
      }
      if (k2.indexOf('.') > 0) {
        if (k2[k2.indexOf('.') + 1] >= 5) {
          return `${Math.floor(num * k) / k}`;
        }
        return `${Math.ceil(num * k) / k}`;
      }
      return `${Math.ceil(num * k) / k}`;
    };
    s = (prec ? toFixedFix(n, prec) : `${Math.round(n)}`).split('.');
    const re = /(-?\d+)(\d{3})/;
    while (re.test(s[0])) {
      s[0] = s[0].replace(re, `$1${sep}$2`);
    }

    // 追加小数点后0
    if ((s[1] || '').length < prec) {
      s[1] = s[1] || '';
      s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    return s.join(dec);
  },
  formatUrl(api) {
    let { domain } = document;
    if (domain.indexOf('localhost') >= 0) {
      domain = 'demo.oa.ychcapital.com';
    }
    return `http://${domain}${api}`;
  },
  build(url, params) {
    // URL构建方法
    const ps = [];
    if (params) {
      Object.keys(params).forEach(p => {
        if (p) {
          ps.push(`${p}=${encodeURIComponent(params[p])}`);
        }
      });
    }
    return url + (url.indexOf('?') === -1 ? '?' : '&') + ps.join('&');
  },
};

export default utils;



// WEBPACK FOOTER //
// ./src/util/index.js